/**
 * @generated SignedSource<<499339bce1a7d8f9dc3a13aa6310198a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type NoteStreamType = "goalset" | "meeting" | "oneonone" | "personal";
import { FragmentRefs } from "relay-runtime";
export type ActionItemLinkageModalNoteInfo$data = {
  readonly id: string;
  readonly note: {
    readonly id: string;
    readonly noteuserSet: ReadonlyArray<{
      readonly id: string;
      readonly user: {
        readonly fullName: string;
        readonly id: string;
      };
    }>;
    readonly stream: {
      readonly displayName: string;
      readonly id: string;
      readonly type?: NoteStreamType;
      readonly url: string | null;
    };
    readonly title: string;
  };
  readonly url: string;
  readonly " $fragmentType": "ActionItemLinkageModalNoteInfo";
};
export type ActionItemLinkageModalNoteInfo$key = {
  readonly " $data"?: ActionItemLinkageModalNoteInfo$data;
  readonly " $fragmentSpreads": FragmentRefs<"ActionItemLinkageModalNoteInfo">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ActionItemLinkageModalNoteInfo",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "note",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "NoteUser",
          "kind": "LinkedField",
          "name": "noteuserSet",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "User",
              "kind": "LinkedField",
              "name": "user",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "fullName",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "stream",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "displayName",
              "storageKey": null
            },
            (v1/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "type",
                  "storageKey": null
                }
              ],
              "type": "NoteStream",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "NoteBlock",
  "abstractKey": null
};
})();

(node as any).hash = "d69dbc81073955ae33b4271c47e3b034";

export default node;
